import { render, staticRenderFns } from "./FAQBoard.vue?vue&type=template&id=2a1b430f&scoped=true"
import script from "./FAQBoard.vue?vue&type=script&lang=js"
export * from "./FAQBoard.vue?vue&type=script&lang=js"
import style0 from "./FAQBoard.vue?vue&type=style&index=0&id=2a1b430f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b430f",
  null
  
)

export default component.exports